import React, { FC, useState } from "react";
import Layout from "../Common/NewLayout";
import Header from "../Common/NewLayout/Header";
import LegalPlaceText from "./LegalPlaceText";
import { Box, makeStyles } from "@material-ui/core";
import { CustomButton } from "../Ui/CustomButton";
import { useNavigate } from "react-router-dom";
import { useMutation, useQuery } from "@apollo/client";
import { useToastNotifications } from "../../utils/toastUtils";
import { Building, UserPlus } from "lucide-react";
import { CHECK_PAYMENT_STRIPE } from "../../graphql/onboarding/stripe/query";
import {
  CheckPaymentStripe,
  CheckPaymentStripeVariables,
} from "../../graphql/onboarding/stripe/types/CheckPaymentStripe";
import { Payment_Status } from "../../enums/stripe";
import { SEND_MAIL_LEGAL_PLACE } from "../../graphql/onboarding/legalPlace/mutation";
import {
  SendMailLegalplace,
  SendMailLegalplaceVariables,
} from "../../graphql/onboarding/legalPlace/types/SendMailLegalplace";

const useStyles = makeStyles((theme) => ({
  button: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "@media (max-width: 450px)": {
      flexDirection: "column",
    },
    marginTop: "2rem",
  },
}));
const LegalPlaceProvider: FC = () => {
  const navigate = useNavigate();
  const classes = useStyles();
  const { showErrorToast } = useToastNotifications();
  const [disabled, setDisabled] = useState(true);

  const { loading: checkStripeLoading } = useQuery<
    CheckPaymentStripe,
    CheckPaymentStripeVariables
  >(CHECK_PAYMENT_STRIPE, {
    variables: { changeStep: true },
    onCompleted: ({ checkPaymentStripe }) => {
      if (checkPaymentStripe !== Payment_Status.PAID) {
        showErrorToast({
          description:
            "Nous n’avons pas encore reçu le règlement des frais de création de votre entreprise. Merci de procéder au paiement.",
        });
        returnPreviousHistory();
      } else {
        setDisabled(false);
      }
    },
    onError: () => {
      showErrorToast({
        description:
          "Une erreur est survenue lors de la vérification du paiement des frais de création de votre entreprise.",
      });
      returnPreviousHistory();
    },
  });

  const [sendMail, { loading }] = useMutation<
    SendMailLegalplace,
    SendMailLegalplaceVariables
  >(SEND_MAIL_LEGAL_PLACE, {
    onError: (error) => {
      let message = "other.error";
      if (error.graphQLErrors) message = "server.error";
      else if (error.networkError) message = "network.error";
      showErrorToast({ description: message });
    },
  });

  const returnPreviousHistory = () => {
    setTimeout(() => {
      navigate("/package");
    }, 5000);
  };

  const navigateTo = (url: string) => {
    if (!disabled) {
      const urlSucces = window.location.href.replace("legalplace", "resume");
      sendMail({
        variables: { urlSucces },
      }).then(() => (window.location.href = url));
    }
  };

  return (
    <Layout
      description="Plus que quelques clics pour créer votre entreprise"
      loading={checkStripeLoading}
    >
      <Header
        title="Créez votre entreprise simplement et rapidement !"
        description={
          <>
            La solution simple pour obtenir ses statuts signés et son KBIS en
            quelques clics et sans soucis grâce à notre partenaire{" "}
            <strong>LegalPlace</strong>
          </>
        }
      />
      <LegalPlaceText />
      <Box className={classes.button}>
        <CustomButton
          type="button"
          variant="primary"
          onClick={() =>
            navigateTo(
              "https://creation.legalplace.fr/creation-entreprise-2?utm_source=affilae&utm_medium=partner&utm_campaign=Sapheer&ae=915",
            )
          }
          label="Entreprise"
          fullWidthMobile
          startIcon={<Building className="w-4 h-4 mr-2" />}
          disabled={disabled}
          loading={loading}
        />
        <CustomButton
          type="button"
          variant="primary"
          onClick={() =>
            navigateTo(
              "https://www.legalplace.fr/contrats/creation-micro-entreprise/?utm_source=affilae&utm_medium=partner&utm_campaign=Sapheer&ae=915",
            )
          }
          label="Micro-entreprise"
          fullWidthMobile
          startIcon={<UserPlus className="w-4 h-4 mr-2" />}
          disabled={disabled}
          loading={loading}
        />
      </Box>
    </Layout>
  );
};

export default LegalPlaceProvider;
